import { SessionService } from '@users/session/SessionService';
import Container from '@framework/di/Container';
import isServer from '@framework/router/Next/isServer';
import ClientReqData from '@framework/router/Next/headers/ClientReqData';
import { X_PATH_WITH_QUERY } from '@framework/router/Next/headers/setPathWithQueryToRequestHeader';
import TenantConfig from '@framework/tenant/TenantConfig';
import config from '@framework/config';
import { buildUrl } from '@framework/url/helpers';

export async function checkSessionWithZeroTolerance(container: Container) {
  const sessionService: SessionService = container.get(SessionService);

  if (isServer()) {
    const { headers } = await container.getAsync<ClientReqData>(ClientReqData);
    const currentHost = headers.currentHost!;
    const { code: tenant } = TenantConfig.fromHostname(currentHost);
    const callbackUrl = buildUrl(config.protocol, currentHost, headers[X_PATH_WITH_QUERY] || '');

    const logoutOnServer = (logoutParams?: { error?: boolean }) => sessionService.logoutOnServer({
      tenant,
      callbackUrl,
      isAutoLogout: true,
      error: logoutParams?.error,
    });

    if (!sessionService.isZeroToleranceAccess()) {
      return sessionService.checkSession({
        logoutParams: { autoLogout: true, error: true },
        clearCache: true,
        logoutHandler: logoutOnServer,
      });
    }
    return logoutOnServer();
  }

  if (!sessionService.isZeroToleranceAccess()) {
    return sessionService.checkSession({
      logoutParams: { autoLogout: true, error: true },
      clearCache: true,
    });
  }
  return sessionService.logout();
}
